import React, { useEffect } from 'react'
import { useMutation } from '@apollo/client'
import { FormProvider, useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Box from '../../../Global/Box'
import 'react-quill/dist/quill.snow.css'
import ReactQuill from 'react-quill'
import { GET_ALL_CONFIG_APP_PAGES } from '../../../../graphql/ConfigApp/configAppPages'
import {
  CREATE_OR_UPDATE_ELEMENT_HtmlContent,
  GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
} from '../../../../graphql/ConfigApp/configAppPageElements'

const refetchConfigsAppPage = {
  query: GET_ALL_CONFIG_APP_PAGES,
  variables: {
    limit: 10,
    offset: 0,
    searchQuery: null,
  },
}

const HtmlContent = ({ pageId, dataElement, setDataElement }) => {
  //MUTATIONS:
  const [createOrUpdate] = useMutation(CREATE_OR_UPDATE_ELEMENT_HtmlContent)

  //FORM:
  const validationSchema = Yup.object().shape({
    htmlContent: Yup.string().required('Campo requerido'),
  })

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  })

  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = methods

  const handleCancel = () => setDataElement(null)

  const onSubmit = async (dataForm) => {
    try {
      let message = ''

      if (dataElement?.id) {
        //Es actualizacion
        const variables = {
          inputGeneral: {
            id: dataElement.id,
            config_app_page_id: dataElement.config_app_page_id,
            order: dataElement.order,
            layout: dataElement.layout,
          },
          inputElement: {
            htmlContent: dataForm.htmlContent,
          },
        }
        await createOrUpdate({
          variables,
          refetchQueries: [
            {
              query: GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
              variables: { configAppPageId: pageId },
            },
          ],
        })
        message = 'Se actualizo correctamente'
      } else {
        //Es nuevo
        const variables = {
          inputGeneral: {
            id: null,
            config_app_page_id: dataElement.config_app_page_id,
            order: null,
            layout: dataElement.layout,
          },
          inputElement: {
            htmlContent: dataForm.htmlContent,
          },
        }
        await createOrUpdate({
          variables,
          refetchQueries: [
            { ...refetchConfigsAppPage },
            {
              query: GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
              variables: { configAppPageId: pageId },
            },
          ],
        })
        message = 'Se creo con exito'
      }

      setDataElement(null)

      return toastSweetAlert({ mode: 'ok', message })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  useEffect(() => {
    if (dataElement?.id) {
      const data = dataElement
      const dataFormated = {
        htmlContent: data.itemMain.htmlContent,
      }
      reset(dataFormated)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataElement])

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            withCard={false}
            title="Elemento"
            btnSecondFunctionTitle="Cancelar"
            btnSecondFunction={() => handleCancel()}
            errors={errors}
            btnSubmit={true}
            content={
              <div className="row">
                <div className="mb-3 col-12">
                  <Controller
                    name="htmlContent"
                    control={control}
                    render={({ field }) => (
                      <ReactQuill
                        {...field}
                        theme="snow"
                        placeholder="Escribe contenido HTML"
                      />
                    )}
                  />
                </div>
              </div>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default HtmlContent
